var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["tabs", ..._vm.variantClassList] }, [
    _vm.$slots.buttons &&
    (_vm.variant === "verticalBg0" ||
      _vm.variant === "verticalBg1" ||
      _vm.variant === "verticalBg2")
      ? _c("div", { staticClass: "tabs__btns" }, [_vm._t("buttons")], 2)
      : _vm._e(),
    _c("div", { staticClass: "tabs__container" }, [
      _c("div", { staticClass: "tabs__header" }, [
        _c(
          "ul",
          { staticClass: "tabs__header-items", style: _vm.tabStyle },
          _vm._l(_vm.tabs, function(tab) {
            return _c(
              "li",
              {
                key: tab.index,
                class: [
                  "tabs__header-item",
                  _vm.currentTabIndex === tab.index && "is-active",
                  tab.disabled && "no-interactive"
                ],
                attrs: { tabindex: "0" },
                on: {
                  click: function($event) {
                    !tab.disabled ? _vm.onTabClick(tab.index) : null
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    class: [
                      "tabs__header-element",
                      tab.disabled && "is-disabled"
                    ]
                  },
                  [
                    _vm.$slots["headerItem" + tab.index] === undefined
                      ? _c(
                          "div",
                          { staticClass: "tabs__header-element-content" },
                          [
                            tab.title
                              ? _c("span", { staticClass: "tabs__title" }, [
                                  _vm._v(" " + _vm._s(tab.title) + " ")
                                ])
                              : _vm._e(),
                            tab.subTitle
                              ? _c("span", { staticClass: "tabs__sub-title" }, [
                                  _vm._v(" " + _vm._s(tab.subTitle) + " ")
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    (tab.indicator || tab.tabIcon || tab.indicatorValue) &&
                    _vm.$slots["headerItem" + tab.index] === undefined
                      ? _c("TabIconBadge", {
                          attrs: {
                            indicator: tab.indicator,
                            tabIcon: tab.tabIcon,
                            dataBg: tab.dataBg,
                            dataColor: tab.dataColor,
                            indicatorValue: tab.indicatorValue
                          }
                        })
                      : _vm._e(),
                    _vm._t("headerItem" + tab.index)
                  ],
                  2
                )
              ]
            )
          }),
          0
        ),
        _vm.$slots.buttons &&
        !(
          _vm.variant == "verticalBg0" ||
          _vm.variant == "verticalBg1" ||
          _vm.variant == "verticalBg2"
        )
          ? _c("div", { staticClass: "tabs__btns" }, [_vm._t("buttons")], 2)
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "tabs__tab-content", style: _vm.tabContentStyle },
        [_vm._t(_vm.currentTabIndex)],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }